import React, { Component }     from "react";
import { Button, MenuItem, Modal, Glyphicon, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import LoaderButton                 from "../../components/LoaderButton";
import { Colors }                   from "../../utils/Colors";
import Form                         from "react-jsonschema-form";
import { schema, uiSchema }         from "../../components/assessment/schema/HeartAndBlood"
import { invokeSetAddHeartBloodAssessment,
         invokeGetAssessmentDetail} from "../../utils/AwsInvoke";
import '../../css/assessment/HeartAndBloodForm.css';

//const log = (type) => console.log.bind(console, type);
// FORM DOCS: https://react-jsonschema-form.readthedocs.io/en/latest/#react-jsonschema-form

const onError = (errors) => console.log("I have", errors.length, "errors to fix");

let assess_form;

const tooltipHDLLabel = ( <Tooltip id="" className="heart-tooltip-holder">
                                <img className="heart-tooltip-hdl-img" src = {require('../../images/misc/assessment/hdl.png')} alt="" />
                           </Tooltip> );

const tooltipLDLLabel = ( <Tooltip id="" className="heart-tooltip-holder">
                               <img className="heart-tooltip-hdl-img" src = {require('../../images/misc/assessment/ldl.png')} alt="" />
                          </Tooltip> );

const tooltipTotalCholLabel = ( <Tooltip id="" className="heart-tooltip-holder">
                                      <img className="heart-tooltip-hdl-img" src = {require('../../images/misc/assessment/total_cholesterol.png')} alt="" />
                                 </Tooltip> );

export default class HeartAndBloodForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            restingHeartRate:          "",
            systolicBloodPressure:     "",
            diastolicBloodPressure:    "",
            heartRateVariabilityScore: "",
            highDensityLipoproteinHDL: "",
            lowDensityLipoproteinLDL:    "",
            totalCholesterol:          "",
            totalCholesterolRatio:     ""
        }

       this.handleInputChange = this.handleInputChange.bind(this);
    }

    async componentWillMount () {
        var assessment_id = this.props.assessmentId;

        if(assessment_id != "undefined") {
            var action     = "existing";
            var client_id        = this.props.clientId;
            var assessment_id    = this.props.assessmentId;

            var screen = "getHeartAndBloodAssessment";
            const results = await invokeGetAssessmentDetail(screen, action, client_id, assessment_id);

            if(results) {
                var restingheartrate          = results.data[0].restingheartrate;
                var systolicbloodpressure     = results.data[0].systolicbloodpressure
                var diastolicbloodpressure    = results.data[0].diastolicbloodpressure
                var heartratevariabilityscore = results.data[0].heartratevariabilityscore
                var hdl                       = results.data[0].hdl;
                var ldl                       = results.data[0].ldl;
                var totalCholesterol          = results.data[0].totalcholesterol;
                var totalcholesterolratio     = results.data[0].totalcholesterolratio;

                if(restingheartrate == null) restingheartrate = "";
                if(systolicbloodpressure == null) systolicbloodpressure = "";
                if(diastolicbloodpressure == null) diastolicbloodpressure = "";
                if(heartratevariabilityscore == null) heartratevariabilityscore = "";
                if(hdl == null) hdl = "";
                if(ldl == null) ldl = "";
                if(totalCholesterol == null) totalCholesterol = "";
                if(totalcholesterolratio == null) totalcholesterolratio = "";

                this.setState({
                    restingHeartRate:          restingheartrate,
                    systolicBloodPressure:     systolicbloodpressure,
                    diastolicBloodPressure:    diastolicbloodpressure,
                    heartRateVariabilityScore: heartratevariabilityscore,
                    highDensityLipoproteinHDL: hdl,
                    lowDensityLipoproteinLDL:  ldl,
                    totalCholesterol:          totalCholesterol,
                    totalCholesterolRatio:     totalcholesterolratio
                });
            }
        }
    }


    handleSubmit = async event => {

        event.preventDefault();
        var client_id                   = this.props.clientId;
        var assessment_id               = this.props.assessmentId;
        var assessment_type             = 4; // heart and blood is #4 in dropdown
        var restingHeartRate            = this.state.restingHeartRate;
        var systolicBloodPressure       = this.state.systolicBloodPressure;
        var diastolicBloodPressure      = this.state.diastolicBloodPressure;
        var heartRateVariabilityScore   = this.state.heartRateVariabilityScore;
        var hdl                         = this.state.highDensityLipoproteinHDL;
        var ldl                         = this.state.lowDensityLipoproteinLDL;
        var totalCholesterol            = this.state.totalCholesterol;
        var totalCholesterolRatio       = totalCholesterol/hdl; //       = this.state.totalCholesterolRatio;

        if(isNaN(totalCholesterolRatio))totalCholesterolRatio = 0;

        var action = "";
        if(assessment_id === "undefined") action = "new";

        var exists = this.props.checkIfMemberAndTitleTFExists();
        if(!exists) return; // if there's no member name or title then you can't submit the form

        this.setState({
            isLoading: true
        })

        var results = await this.props.addAssessmentToDB(assessment_type);

        if(results.status === true) {
            var assessment_id = results.assessment_id;

            var results2 = await invokeSetAddHeartBloodAssessment(action, assessment_id, client_id, restingHeartRate, systolicBloodPressure, diastolicBloodPressure, heartRateVariabilityScore, hdl, ldl, totalCholesterol, totalCholesterolRatio)

            if(results2.status === true)
                this.props.cancelAssessment();
        } else
            this.setState({
                isLoading: false
            })
    }

    handleInputChange(event) {
          const target = event.target;
          const value = target.type === 'checkbox' ? target.checked : target.value;
          const name = target.name;

          this.setState({
            [name]: value
          });
    }

    render() {
        var total_cholesterol_ratio = 0;
        var hdl = this.state.highDensityLipoproteinHDL;
        var total_chol            = this.state.totalCholesterol;
        total_cholesterol_ratio = total_chol/hdl;

        if(isNaN(total_cholesterol_ratio))total_cholesterol_ratio = 0;

        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>

                <form onSubmit={this.handleSubmit} className="form">
                    <div className="grid parqRowFullWidth heart_textarea_box">
                            <div className="primal_title">
                            Resting Heart Rate
                            </div>
                            <div className="heart-total-chol-ratio"></div>
                            <input
                                name      = "restingHeartRate"
                                className = "heart_textfield_long_width"
                                value     = {this.state.restingHeartRate}
                                onChange  = {this.handleInputChange} />

                    </div>
                    <div className="iconAddExerciseVertSpacer"></div>
                    <div className="grid parqRowFullWidth heart_textarea_box">
                            <div className="primal_title">
                            Systolic Blood Pressure
                            </div>
                            <div className="heart-subtitle">(Normal systolic blood pressure is less than 120)</div>
                            <input
                                name      = "systolicBloodPressure"
                                className = "heart_textfield_long_width"
                                value     = {this.state.systolicBloodPressure}
                                onChange  = {this.handleInputChange} />
                    </div>
                    <div className="iconAddExerciseVertSpacer"></div>
                    <div className="grid parqRowFullWidth heart_textarea_box">
                            <div className="primal_title">
                            Diastolic Blood Pressure
                            </div>
                            <div className="heart-subtitle">(Normal diastolic blood pressure is less than 80)</div>
                            <input
                                name      = "diastolicBloodPressure"
                                className = "heart_textfield_long_width"
                                value     = {this.state.diastolicBloodPressure}
                                onChange  = {this.handleInputChange} />

                    </div>
                    <div className="iconAddExerciseVertSpacer"></div>
                    <div className="grid parqRowFullWidth heart_textarea_box">
                            <div className="primal_title">
                            Heart Rate Variability Score
                            </div>
                            <div className="heart-subtitle">(Try to use one tool of measure)</div>
                            <input
                                name      = "heartRateVariabilityScore"
                                className = "heart_textfield_long_width"
                                value     = {this.state.heartRateVariabilityScore}
                                onChange  = {this.handleInputChange} />
                    </div>
                    <div className="iconAddExerciseVertSpacer"></div>
                    <div className="grid parqRowFullWidth heart_textarea_box">
                            <div className="primal_title">
                            High-Density Lipoprotein (HDL)
                            <OverlayTrigger placement="top" overlay={tooltipHDLLabel} >
                                <Glyphicon glyph="question-sign" className="tooltipIcon" style={{position:"relative", top:"0px", left:"5px", color:"#666"}}/>
                            </OverlayTrigger>
                            </div>
                            <div className="heart-subtitle">(Milligrams per deciliter (mg/dL))</div>
                            <input
                                name      = "highDensityLipoproteinHDL"
                                className = "heart_textfield_long_width"
                                value     = {this.state.highDensityLipoproteinHDL}
                                onChange  = {this.handleInputChange} />

                    </div>
                    <div className="iconAddExerciseVertSpacer"></div>
                    <div className="grid parqRowFullWidth heart_textarea_box">
                            <div className="primal_title">
                            Low-Density Lipoprotein (LDL)
                            <OverlayTrigger placement="top" overlay={tooltipLDLLabel} >
                                <Glyphicon glyph="question-sign" className="tooltipIcon" style={{position:"relative", top:"0px", left:"5px", color:"#666"}}/>
                            </OverlayTrigger>
                            </div>
                            <div className="heart-subtitle">(Milligrams per deciliter (mg/dL))</div>
                            <input
                                name      = "lowDensityLipoproteinLDL"
                                className = "heart_textfield_long_width"
                                value     = {this.state.lowDensityLipoproteinLDL}
                                onChange  = {this.handleInputChange} />

                    </div>
                    <div className="iconAddExerciseVertSpacer"></div>
                    <div className="grid parqRowFullWidth heart_textarea_box">
                            <div className="primal_title">
                            Total Cholesterol (HDL/LDL)
                            <OverlayTrigger placement="top" overlay={tooltipTotalCholLabel} >
                                <Glyphicon glyph="question-sign" className="tooltipIcon" style={{position:"relative", top:"0px", left:"5px", color:"#666"}}/>
                            </OverlayTrigger>
                            </div>
                            <div className="heart-subtitle">(Milligrams per deciliter (mg/dL))</div>
                            <input
                                name      = "totalCholesterol"
                                className = "heart_textfield_long_width"
                                value     = {this.state.totalCholesterol}
                                onChange  = {this.handleInputChange} />

                    </div>
                    <div className="iconAddExerciseVertSpacer"></div>
                    <div className="grid parqRowFullWidth heart_textarea_box">
                            <div className="primal_title">
                            Total Cholesterol Ratio

                            </div>
                            <div className="heart-subtitle">[Men 5.0 = average risk 3.4 = half the average risk 9.6 = twice the average risk] [Women 4.4 = average risk 3.3 = half the average risk 7.0 = twice the average risk]</div>
                            <input
                                name      = "totalCholRatio"
                                className = "heart_textfield_long_width"
                                value     = {total_cholesterol_ratio}
                                onChange  = {this.handleInputChange} />
                    </div>
                    <div className="iconAddExercise25pxVertSpacer"></div>
                    <div className="iconAddExercise25pxVertSpacer"></div>
                    <Row className="grid" >
                          <Col xs={6} sm={6} md={6}>
                                <span onClick = { () => this.props.cancelAssessment()}
                                    style={{display:"inline-block", paddingLeft: "20px !important", width:"100%"}}>
                                      <LoaderButton
                                        block
                                        type    = "button"
                                        text    = "Cancel"
                                        style   = {{ fontSize:18, height:42, color:"black", backgroundColor: "#ccc"}}
                                      />
                                </span>
                          </Col>
                          <Col xs={6} sm={6} md={6}>
                                <span style={{position: "relative", left:30, display:"inline-block", width:"100%"}}>
                                      <LoaderButton
                                        block
                                        style   = {{ fontSize:18, height:42, color:"white", fontWeight: "bold", backgroundColor: Colors.ok_button_bg}}
                                        //disabled={!this.validateForm()}
                                        isLoading={this.state.isLoading}
                                        text    = "Save"
                                        type    = "submit"
                                        loadingText="Saving …"
                                      />
                                </span>
                            </Col>
                     </Row>
             </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/assessment/HeartAndBloodForm.js